<template>
  <v-row no-gutters class="mt-12">
    <v-col cols="1" md="1" xs="12" sm="12"></v-col>
    <v-col cols="12" md="10" xs="12" sm="12">
      <div class="cardTable mt-8">
  <v-row no-gutters class="">
      <v-col cols="12"
        md="10"
        xs="12"
        sm="12">
        <v-tabs background-color="transparent" v-model="tabs">
    <v-tab key="1">{{$t("table.recording") }}</v-tab>
  </v-tabs>
      </v-col>
      <v-col cols="12"
        md="2"
        xs="12"
        sm="12"
        class="mt-2">
        <v-btn block
        @click="backhome"
        style="font-family: Sarabun;
        font-size: 16px;
        font-weight: 500;"
        depressed
        color="primary">
        {{$t("button.btnback") }}
        </v-btn>
      </v-col>
    </v-row>
  <v-card
  class="mx-auto"
  max-width="100%"
  outlined
>
  <v-tabs-items v-model="tabs">
    <v-row class="pl-8 mt-2">
      <v-col cols="12"
        md="12"
        xs="12"
        sm="12">
        <v-icon  color="#0355CB">mdi-account-group</v-icon>
       <span> {{$t("table.recording") }} {{ datavideo.length }} {{$t("table.list") }} </span>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-simple-table>
    <template v-slot:default>
    <thead >
    <tr>
      <th class="text-center">
        {{$t("table.No") }}
      </th>
      <th class="text-center">
        {{$t("loginpage.name") }}
      </th>
      <th class="text-center">
        {{$t("table.size") }}
      </th>
      <th class="text-center">
        {{$t("table.manage") }}
      </th>
    </tr>
    </thead>
    <tbody>
      <tr
        v-for="(item, key) in datavideo"
        :key="key"
      >
        <td class="text-center">{{ key+1 }}</td>
        <td class="text-center">{{ item.filename }}</td>
        <td class="text-center">
          {{ item.size }}
        </td>
        <td class="text-center">
          <!-- <v-icon @click="deleteFile(item.file_id)" color="#0355CB">mdi-delete-empty</v-icon> -->
          <v-icon @click="downloadreportvideo(item.file_id)" color="#0355CB" class="pl-2">mdi-tray-arrow-down</v-icon>
          <span style="color: #0355CB;">
            {{$t("table.downloadrecord") }}.mp4
          </span>
        </td>
        </tr>
      </tbody>
     </template>
    </v-simple-table>
  </v-tabs-items>
  </v-card>
  <v-dialog
   v-if="($vuetify.breakpoint.lg || $vuetify.breakpoint.md || $vuetify.breakpoint.xl || $vuetify.breakpoint.xxl)"
    v-model="dialog"
    :scrim="false"
    persistent
    width="50%">
    <v-card
      color=""
    >
    <div class="spinnerContainer">
  <div class="spinner mt-6"></div>
  <div class="loader">
    <p>Please Stand by . . .</p>
    <div class="words">
      <span class="word">loading</span>
      <span class="word">File</span>
      <span class="word">Video</span>
      <span class="word">Record</span>
      <span class="word">Just Moment</span>
    </div>
  </div>
</div>
    </v-card>
  </v-dialog>
  <v-dialog
  v-if="($vuetify.breakpoint.xs || $vuetify.breakpoint.sm )"
    v-model="dialog"
    :scrim="false"
    persistent
    width="100%">
    <v-card
      color=""
    >
    <div class="spinnerContainer">
  <div class="spinner mt-6"></div>
  <div class="loader2">
    <p>Please Stand by . .</p>
    <div class="words">
      <span class="word"> loading</span>
      <span class="word"> File</span>
      <span class="word"> Video</span>
      <span class="word"> Record</span>
      <span class="word"> Just Moment</span>
    </div>
  </div>
</div>
    </v-card>
  </v-dialog>
  <v-dialog
  v-if="($vuetify.breakpoint.lg || $vuetify.breakpoint.md || $vuetify.breakpoint.xl || $vuetify.breakpoint.xxl)"
    v-model="dialogdownload"
    :scrim="false"
    persistent
    width="50%">
    <v-card
      color=""
    >
    <div class="spinnerContainer">
  <div class="spinner mt-6"></div>
  <div class="loader">
    <p>Please Stand by . . {{ percentCompleted }}%</p>
  </div>
</div>
      <!-- <v-card-text>
        {{$t("loginpage.Pleasestandby") }} 
        <span style="font-size: 40px;"> . . . . </span>
        <v-progress-linear
            v-model="percentCompleted"
            height="25"
          >
            <strong>{{ percentCompleted }}%</strong>
          </v-progress-linear>
      </v-card-text> -->
    </v-card>
  </v-dialog>
  <v-dialog
  v-if="($vuetify.breakpoint.xs || $vuetify.breakpoint.sm )"
    v-model="dialogdownload"
    :scrim="false"
    persistent
    width="100%">
    <v-card
      color=""
    >
    <div class="spinnerContainer">
  <div class="spinner mt-12"></div>
  <div class="loader2">
    <p>Please Stand by . . {{ percentCompleted }}%</p>
  </div>
</div>
      <!-- <v-card-text>
        {{$t("loginpage.Pleasestandby") }} 
        <span style="font-size: 40px;"> . . . . </span>
        <v-progress-linear
            v-model="percentCompleted"
            height="25"
          >
            <strong>{{ percentCompleted }}%</strong>
          </v-progress-linear>
      </v-card-text> -->
    </v-card>
  </v-dialog>
<v-card
  class="mx-auto"
  max-width="100%"
  max-height="100%"
  outlined>
  <v-row>
    <v-col>
    </v-col>
  </v-row>
  <v-row>
    <v-col>
    </v-col>
  </v-row>
  <v-row>
    <v-col>
    </v-col>
  </v-row>
</v-card>
</div>
</v-col>
</v-row>
</template>
<script>
import { mapState } from 'vuex'
export default {
data() {
  return {
    jwt: require('jsonwebtoken'),
    datavideo: '',
    fileid: '',
    meetid:'',
    tabs: null,
    dialog: false,
    dialogdownload: false,
    interval: {},
    value: 0,
    percentCompleted:0,
  }
},
watch: {
},
computed: {
  ...mapState('dialog', ['donwloadvideo']),
},
created() {
},
mounted() {
  this.meetid = this.donwloadvideo
  // console.log('this.meetid', this.meetid)
  if (this.meetid === '') {
      window.open('/', '_self')
  } else {
  this.openModalvideo()
  }
},
methods: {
  openModalvideo() {
    this.axios.post(process.env.VUE_APP_API + '/api/lv1/onebox/getrecord/' + this.meetid).then(res => {
      this.datavideo = JSON.parse(this.decodeJS(res.data.data))
      // console.log('openModalvideo', this.datavideo)
      // this.datavideo = res.data.data
    }).catch(err => {
      console.log('ERROR:openModalvideo', err)
    })

  },
  decodeJS(data) {
      try {
        var bytes = this.CryptoJS.AES.decrypt(
          data,
          process.env.VUE_APP_SECRET_KEY
        )
        var decryptedData = JSON.parse(bytes.toString(this.CryptoJS.enc.Utf8))
        return decryptedData
      } catch (error) {
        console.log('>>>>>>>>', error)
        return error
      }
    },

  deleteFile(fileid) {
    this.$swal
      .fire({
        title: this.$t("message.yousure"),
        text: '',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#04449F',
        confirmButtonText: this.$t("button.btnok"),
        cancelButtonColor: '#D63A3A',
        cancelButtonText: this.$t("button.btncancel")
      }).then(res => {
        if (res.isConfirmed === true) {
          this.axios.delete(process.env.VUE_APP_API + '/api/v1/onebox/delete', {
            data: {
              file_id: fileid
            }
          }).then(res => {
            this.$swal(res.data.result, res.data.message, 'success')
            // console.log('setItem', result.data.token)
            this.openModalvideo()
          }).catch(err => {
            console.log('ERROR:deletefile', err)
          })
        } else {
          console.log('Cancel')
        }
      })
  },
  downloadreportvideo(fileId) {
        // console.log('fileId', fileId)
    this.dialog = true
    this.axios.get(process.env.VUE_APP_API + '/api/lv1/onebox/download/' + this.meetid + '/' + fileId, {
      responseType: 'arraybuffer',
      onDownloadProgress: progressEvent => {
        // console.log('progressEvent.loaded', progressEvent.loaded)
        // console.log('progressEvent.total', progressEvent.total)
        this.percentCompleted = Math.floor(progressEvent.loaded / progressEvent.total * 100)
        if(this.percentCompleted >=1) {
          this.dialog = false
          this.dialogdownload = true
        }
        // console.log('this.percentCompleted', this.percentCompleted)
        if(this.percentCompleted === 100) {
          this.percentCompleted = 0
          this.dialogdownload = false
        }
    }}).then(res => {
      const blob = new Blob([res.data], { type: 'application/mp4' })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = fileId + '.mp4'
      link.click()
      this.dialog = false
      // this.datavideo = res.data.data
    }).catch(err => {
      this.dialog = false
      console.log('ERROR:openModalvideo', err)
    })
  },
  backhome(){
    // this.$router.push('/manage').catch(() => {});
    this.$router.push('/manage?' + 'tabs=' + 1).catch(() => {});
  },
}
}
</script>
<style scoped>
.spinnerContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.spinner {
  width: 56px;
  height: 56px;
  display: grid;
  border: 4px solid #0000;
  border-radius: 50%;
  border-right-color: #299fff;
  animation: tri-spinner 1s infinite linear;
}

.spinner::before,
.spinner::after {
  content: "";
  grid-area: 1/1;
  margin: 2px;
  border: inherit;
  border-radius: 50%;
  animation: tri-spinner 2s infinite;
}

.spinner::after {
  margin: 8px;
  animation-duration: 3s;
}

@keyframes tri-spinner {
  100% {
    transform: rotate(1turn);
  }
}

.loader {
  color: #4a4a4a;
  font-family: "Poppins",sans-serif;
  font-weight: 500;
  font-size: 24px;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  height: 40px;
  padding: 10px 10px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  border-radius: 8px;
}

.loader2 {
  color: #4a4a4a;
  font-family: "Poppins",sans-serif;
  font-weight: 500;
  font-size: 20px;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  height: 40px;
  padding: 10px 10px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  border-radius: 8px;
}
.words {
  overflow: hidden;
}

.word {
  display: block;
  height: 100%;
  padding-left: 6px;
  color: #299fff;
  animation: cycle-words 5s infinite;
}

@keyframes cycle-words {
  10% {
    -webkit-transform: translateY(-105%);
    transform: translateY(-105%);
  }

  25% {
    -webkit-transform: translateY(-100%);
    transform: translateY(-100%);
  }

  35% {
    -webkit-transform: translateY(-205%);
    transform: translateY(-205%);
  }

  50% {
    -webkit-transform: translateY(-200%);
    transform: translateY(-200%);
  }

  60% {
    -webkit-transform: translateY(-305%);
    transform: translateY(-305%);
  }

  75% {
    -webkit-transform: translateY(-300%);
    transform: translateY(-300%);
  }

  85% {
    -webkit-transform: translateY(-405%);
    transform: translateY(-405%);
  }

  100% {
    -webkit-transform: translateY(-400%);
    transform: translateY(-400%);
  }
}

</style>
